module.exports = __webpack_public_path__ + "static/media/failed.2f837031.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/content/instanceScreenshotViewer/instances/instanceControlPanel/maintenanceMonitor/maintenanceCommand/symbols/failed.svg
// module id = 904
// module chunks = 0